import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
  Box
} from '@mui/material';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api';

      const response = await fetch(`${apiBaseUrl}/auth/password-reset/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
      } else {
        setError(data.error || 'Failed to send reset email. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
      console.error('Forgot password error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}>
      <Card>
        <CardContent sx={{ p: { xs: 3, sm: 4, md: 6 } }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontSize: { xs: '1.75rem', sm: '2.125rem' } }}>
            Forgot Password
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: { xs: 3, md: 4 } }}>
            Enter your email address and we'll send you a link to reset your password
          </Typography>

          {success ? (
            <Box>
              <Alert severity="success" sx={{ mb: { xs: 2, md: 3 } }}>
                If an account exists with that email, a password reset link has been sent. Please check your email.
              </Alert>
              <Button
                component={Link}
                to="/login"
                variant="contained"
                fullWidth
                size="large"
              >
                Return to Sign In
              </Button>
            </Box>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <Alert severity="error" sx={{ mb: { xs: 2, md: 3 } }}>
                  {error}
                </Alert>
              )}

              <TextField
                name="email"
                label="Email Address"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                fullWidth
                variant="outlined"
                sx={{ mb: { xs: 3, md: 4 } }}
                autoComplete="email"
                autoFocus
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                disabled={loading}
                sx={{ mb: { xs: 2, md: 3 } }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>

              <Typography align="center" sx={{ mt: { xs: 2, md: 3 } }}>
                Remember your password?{' '}
                <Link
                  to="/login"
                  style={{ color: '#2563eb', fontWeight: 500, textDecoration: 'none' }}
                >
                  Sign in
                </Link>
              </Typography>
            </form>
          )}
        </CardContent>
      </Card>
    </Container>
  );
}

export default ForgotPassword;
